/*
 * Filename: d:\projects\AutoFiFront\src\Utils\UrlParams.ts
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, January 26th 2023, 10:11:17 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

export function GetCurrentCarPage() {
  const searchPage = new URLSearchParams(window.location.search);
  const myPage = searchPage.get("page");
  return myPage == null ? 0 : parseInt(myPage) - 1;
}

export function GetFilters(searchParams: string) {
  const searchFilters = new URLSearchParams(searchParams);
  const myFiltersSelected = searchFilters.get("filters");
  return myFiltersSelected == null || myFiltersSelected.length == 0
    ? []
    : myFiltersSelected.split(",");
}

export function GetOrderBy() {
  const searchOrderBy = new URLSearchParams(window.location.search);
  const orderBy = searchOrderBy.get("orderedby");
  let orderBySelected: string[] = [];
  if (orderBy !== null) orderBySelected = orderBy.split(",");
  return orderBy == null
    ? { name: "", order: "" }
    : { name: orderBySelected[0], order: orderBySelected[1] };
}

export function SearchParamsEquality(
  searchParams1: URLSearchParams,
  searchParams2: URLSearchParams
) {
  return searchParams1.toString() == searchParams2.toString();
}

export function IsThisFilterTrue(minVal: number, filters: string[]) {
  return minVal <= filters.length;
}
